angular.module("changeGoodAddress.components", []).component("changeGoodAddress", {
    templateUrl: "ng/components/changeGoodAddress/changeGoodAddress.view.html",
    bindings: {
        richiestePostVendita: "<"
    },
    controllerAs: "changeAddressCtrl",
    controller: function ChangeAddress(
        $location,
        $arcService,
        $modalService,
        $RichiestePostVenditaService,
        $rootScope,
        RichiestePostVendita,
        Contratti
    ) {
        var self = this;
        self.backIsVisible = false;
        self.showMapInfo = false;
        self.mapInfo = "";

        self.$onInit = function () {
            if (self.richiestePostVendita.viewIndex == 0) {
                self.richiestePostVendita.viewIndex = 1150;
            }

            var contratti = [];
            if (self.richiestePostVendita.metadata.variazioneAnagrafica.contratti.length == 0) {
                self.richiestePostVendita.metadata.ctrRichiestaList.forEach(function (contratto) {
                    contratti.push(Contratti.build({
                        numero: contratto.numeroContratto,
                        modulo: contratto.numeroModulo,
                        selected: true,
                        codProdotto: contratto.codProdotto
                    }));
                });

                self.richiestePostVendita.metadata.variazioneAnagrafica.contratti = contratti;
            }

            if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1' || self.richiestePostVendita.readOnly) {
                self.popolateCheckListDownload();
                self.popolateCheckListUpload();
                self.backIsVisible = true;
            } else {
                self.backIsVisible = false;
            }

            retrieveStepInfo();
        };

        self.validityPage = function (validity) {
            self.changeAddressComponent = validity;
        }

        self.nextValidity = function () {
            return self.changeAddressComponent;
        }

        self.next = function () {
            self.enabledLoader = true;
            if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PII1') {
                $RichiestePostVenditaService
                    .generateDocumentsPv(RichiestePostVendita.build(self.richiestePostVendita))
                    .then(function (response) {
                        if (response.success) {
                            $RichiestePostVenditaService
                                .nextStep(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                                .then(function (response) {
                                    self.enabledLoader = false;
                                    self.richiestePostVendita = response;

                                    if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1') {
                                        retrieveStepInfo();
                                        self.popolateCheckListDownload();
                                        self.popolateCheckListUpload();
                                        self.backIsVisible = true;
                                    }

                                }).catch(function (error) {
                                    console.log(error);
                                    self.enabledLoader = false;
                                });
                        } else {
                            self.enabledLoader = false;
                        }

                    }).catch(function (error) {
                        console.log(error);
                        self.enabledLoader = false;
                    });
            } else if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1') {
                $RichiestePostVenditaService
                    .updateIndBene(self.richiestePostVendita.metadata.variazioneAnagrafica, self.richiestePostVendita.id,
                        self.richiestePostVendita.viewIndex, self.richiestePostVendita.applicationName, self.richiestePostVendita.typeWf)
                    .then(function (response) {
                        self.enabledLoader = false;
                        $location.path('/');
                    }).catch(function (error) {
                        self.enabledLoader = false;
                        console.log(error);
                    });
            }

        }

        self.sospendi = function () {
            $RichiestePostVenditaService
                .suspendInstance(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                .then(function () {
                    $location.path('/');
                    $modalService.closeModal("suspendInstance");
                })
        }

        self.back = function () {
            if (self.richiestePostVendita.readOnly) {
                $location.path('/')

            } else {
                if (self.getWizardMap(self.richiestePostVendita.viewIndex) === 'PCK1') {
                    self.backIsVisible = false
                }
                $RichiestePostVenditaService
                    .backStep(self.richiestePostVendita, self.richiestePostVendita.typeWf, self.richiestePostVendita.applicationName, true)
                    .then(function (response) {
                        self.enabledLoader = false;
                        self.richiestePostVendita = response;
                        retrieveStepInfo();
                    }).catch(function (error) {
                        console.log(error);
                        self.enabledLoader = false;
                    })
            }
        }

        self.closeModal = function () {
            $modalService.closeModal("suspendInstance");
        }

        self.getWizardMap = function (viewIndex) {
            if (
                $rootScope.wizardMap.find(function (element) {
                    return element.index == viewIndex;
                })
            ) {
                return $rootScope.wizardMap.find(function (element) {
                    return element.index == viewIndex;
                }).viewName;
            }
        };

        self.popolateCheckListDownload = function () {
            self.restDownloadRunning = true;
            $arcService.downloadDocumentationRichiestaPostVendita(self.richiestePostVendita)
                .then(function (response) {
                    self.listOfDocumentDownload = response.listDocuments;
                    self.visibleDownloadChecklist = response.visible;
                    self.restDownloadRunning = false;
                })
                .catch(function (error) {
                    console.error(error);
                    self.restDownloadRunning = false;
                })
        }

        self.popolateCheckListUpload = function () {
            self.restUploadRunning = true;
            $arcService.uploadDocumentationRichiestaPostVendita(self.richiestePostVendita)
                .then(function (response) {
                    self.listOfDocumentUpload = response.listDocuments;
                    self.visibleUploadChecklist = response.visible;
                    self.message = response.message;
                    self.restUploadRunning = false;
                })
                .catch(function (error) {
                    console.error(error);
                    self.restUploadRunning = false;
                })
        }

        var retrieveStepInfo = function () {
            self.clearLabelInfo = true;
            $RichiestePostVenditaService
                .getStepInfo(self.richiestePostVendita.id, self.richiestePostVendita.viewIndex)
                .then(function (response) {
                    if (response.success) {
                        self.showMapInfo = response.showBeMessage;
                        self.mapInfo = response.message;
                        self.enabledLoader = false;
                    }
                    self.clearLabelInfo = false;
                })
                .catch(function (error) {
                    console.log(error);
                    self.enabledLoader = false;
                    self.clearLabelInfo = false;
                });
        }
    }
});